module.exports = __webpack_public_path__ + "img/iconePedidosEntrega.dc19fb8f.png";